/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Vue} from 'vue-property-decorator';

/**
 * File size validation rule.
 *
 * Creates a custom file size validation rule.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const FileSizeValidator: object = {
    /**
     * Message response.
     * @param {string} field
     * @param args
     * @return {string}
     */
    getMessage(field: any, args: number[]|null): string {
        return Vue.i18n.translate('validator.file-size.error',
            {size: !!args ? (args[0] / 1024 / 1024).toFixed(1) : ''}) ||
            'The file you have selected is too big';
    },

    /**
     * Validate the file size.
     *
     * @param {File[] | undefined} value
     * @param {number} size
     *
     * @returns {boolean}
     */
    validate(value: File|File[]|undefined|null, {size}: {size: number}): boolean {
        if (undefined === value || null === value) {
            return false;
        }

        const files: File[] = (value instanceof File) ? [value] : value;

        for (const file of files) {
            if (file.size > size) {
                return false;
            }
        }

        return true;
    },
};
